import { render, staticRenderFns } from "./HorizontalBubbleCard.vue?vue&type=template&id=a47fd59e&scoped=true&lang=pug&"
import script from "./HorizontalBubbleCard.vue?vue&type=script&lang=js&"
export * from "./HorizontalBubbleCard.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalBubbleCard.vue?vue&type=style&index=0&id=a47fd59e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47fd59e",
  null
  
)

export default component.exports